module.exports = __webpack_public_path__ + "gif/almost.gif";